import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { ExperimentationService } from '../shared/experimentation/experimentation.service'
import {
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING,
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT,
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_VARIATION,
  EXP_NEXT_GEN_EVENT_HUB_WRESTLING_VARIATION
} from '../shared/experimentation/experiment.model'
import { catchError, combineLatest, map, mergeMap, Observable, of } from 'rxjs'
import { PlatformService } from '../singleton-services/platform.service'
import { VerticalService } from '../singleton-services/vertical.service'

@Injectable({
  providedIn: 'root'
})
export class NextGenEventHubGuard implements CanActivate {
  constructor(
    private experimentService: ExperimentationService,
    private platformService: PlatformService,
    private verticalService: VerticalService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([
      this.experimentService.isInVariation(
        EXP_NEXT_GEN_EVENT_HUB_WRESTLING,
        EXP_NEXT_GEN_EVENT_HUB_WRESTLING_VARIATION,
        true
      ),
      this.experimentService.isInVariation(
        EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT,
        EXP_NEXT_GEN_EVENT_HUB_WRESTLING_SHORT_VARIATION,
        true
      )
    ]).pipe(
      mergeMap(([isInLongExperiment, isInShortExperiment]) => {
        // check if the url is for the schedule page
        const isNotNGEventHub =
          state.url === '/events' ||
          state.url === '/events/' ||
          state.url.slice(0, 8) === '/events?' ||
          state.url.slice(0, 9) === '/events/?'
        // check if the url is for a video on the legacy event hub ( TW  needs this )
        const isLegacyVideo = state.url.includes('?playing=')
        if (
          (isInLongExperiment || isInShortExperiment) &&
          this.platformService.isBrowser &&
          !isNotNGEventHub &&
          !isLegacyVideo
        ) {
          return this.verticalService.coreSiteUrl$.pipe(
            map(coreSiteUrl => {
              // Strip everything after the first "-" in the event URL
              const strippedUrl = state.url.replace(/(-.*)$/, '')

              const redirectUrl = `${coreSiteUrl}/nextgen${strippedUrl}/information`
              window.location.href = redirectUrl

              return false
            })
          )
        }
        // If not in the experiment or not a browser, allow navigation
        return of(true)
      }),
      catchError(err => {
        console.error('Error in event-hub guard', err)
        return of(false)
      })
    )
  }
}
